import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerGuideNavigator } from '@/lib/guides/engine';

/** Connects guide `navigate` actions to the app router. Renders nothing. */
export function GuideNavigatorBridge(): null {
  const navigate = useNavigate();

  useEffect(() => {
    return registerGuideNavigator((to) => {
      navigate(to);
    });
  }, [navigate]);

  return null;
}
